import { Alert, Stack, Text } from '@mantine/core';
import { AlertOctagon, RefreshCw } from 'lucide-react';
import { Button, Card } from '../ui';

interface ErrorStateProps {
  title: string;
  message?: string;
  onRetry?: () => void;
}

/**
 * ErrorState — generic fallback for failed data fetches.
 * Pairs with `LoadingState` and `EmptyState` to cover the three loading
 * outcomes mandated by PLAN.md.
 */
export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  return (
    <Card variant="danger">
      <Stack gap="sm" align="center" py="md">
        <Alert color="red" variant="light" icon={<AlertOctagon size={16} />} style={{ width: '100%' }}>
          <Text fw={600} size="sm">
            {title}
          </Text>
          {message ? (
            <Text size="xs" c="dimmed" mt={2}>
              {message}
            </Text>
          ) : null}
        </Alert>
        {onRetry ? (
          <Button variant="secondary" leftIcon={<RefreshCw size={14} />} onClick={onRetry}>
            Retry
          </Button>
        ) : null}
      </Stack>
    </Card>
  );
}
